import { computed, inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface LastCacheRefreshResponse {
  adebsdb: string;
  sgc: string;
}

@Injectable({
  providedIn: 'root',
})
export class CacheRefreshTimeService {
  // == DEPENDENCY INJECTION ===============================
  private httpClient = inject(HttpClient);

  // == STATE =========================================
  private _adebsdbLastRefreshTime = signal<Date | null>(null);
  public readonly adebsdbLastRefreshTime = computed(() => this._adebsdbLastRefreshTime());

  private _sgcLastRefreshTime = signal<Date | null>(null);
  public readonly sgcLastRefreshTime = computed(() => this._sgcLastRefreshTime());

  // == METHODS =========================================
  public updateCacheRefreshTimes(): void {
    const url = 'api/order/last-cache-refresh';
    this.httpClient.get<LastCacheRefreshResponse>(url).subscribe({
      next: (response) => {
        this._adebsdbLastRefreshTime.set(response.adebsdb ? new Date(response.adebsdb) : null);
        this._sgcLastRefreshTime.set(response.sgc ? new Date(response.sgc) : null);
      },
      error: (error) => console.error('Failed to get last cache refresh times', error)
    });
  }
}
